const useIntercomAppStyles: Function = (isEditMode: boolean): MaterialUIStyles => ({
  '.intercom-launcher': {
    display: `${isEditMode ? 'none' : 'block'} !important`,
  },
});

export default useIntercomAppStyles;
